const FAST = 'fast';
const EASY = 'easy';
const NOELEVATORS = 'noelevators';
const MENU_REDIRECT_URL = 'menuRedirectUrl';
const MOTION_EVENTS_PERMISSIONS = 'motionEventsPermissions';

const APP_TYPES = {
    TERMINAL: 'terminal',
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
}

export {
    FAST,
    EASY,
    APP_TYPES,
    NOELEVATORS,
    MENU_REDIRECT_URL,
    MOTION_EVENTS_PERMISSIONS
};

